import { z } from "zod";
import { createLocalizedDateFromUtcDateTimeString } from "../_helpers/dateTime";

export const purchaseOrderItemMessageSchema = z.object({
  purchaseOrderItemMessageId: z.number(),
  messageContent: z.string(),
  sentTime: z.string().transform(createLocalizedDateFromUtcDateTimeString),
  senderName: z.string(),
});
export type PurchaseOrderItemMessage = z.infer<
  typeof purchaseOrderItemMessageSchema
>;

export const purchaseOrderItemMessagesSchema =
  purchaseOrderItemMessageSchema.array();
export type PurchaseOrderItemMessages = z.infer<
  typeof purchaseOrderItemMessagesSchema
>;

export const sendPurchaseOrderItemMessageSchema = z.object({
  messageContent: z.string().max(1500).optional(),
});
export type SendPurchaseOrderItemMessage = z.infer<
  typeof sendPurchaseOrderItemMessageSchema
>;
